import { Alert, Group, Text } from '@mantine/core';
import { FeedbackButton } from 'components/FeedbackButton';
import { tKeys, useTranslation } from 'locales';

export const Feedback = () => {
  const { t } = useTranslation();

  return (
    <Alert
      variant="light"
      radius="lg"
      color="blue.0"
      style={{ border: '1px solid', borderColor: 'var(--mantine-color-blue-2)' }}
    >
      <Group justify="space-between" align="center">
        <Text c="blue.9" size="sm">
          {t(tKeys.MODULES.AT_RISK.FEEDBACK.QUESTION)}
        </Text>
        <FeedbackButton
          featureName="Unhandled tab"
          size="compact-sm"
          variant="default"
          color="white"
          description={t(tKeys.MODULES.AT_RISK.FEEDBACK.DESCRIPTION)}
        />
      </Group>
    </Alert>
  );
};
